const stages = ["development", "testing", "production"];

export { stages };
